import React from 'react';
import FlexGrid from '@tds/core-flex-grid';
import Box from '@tds/core-box';
import PropTypes from 'prop-types';

import FormField from '../formField';
import { BtnMargin, RowBordered } from '../css';
import { officePhoneRowTypes } from '../../utils/constant';
import { getLocalizedStrings } from '../../misc';
import { FieldMultiCheckbox } from '../fields';
import { Error } from '../../design/elements';

const AddForm = ({
  fieldRows,
  onFormSubmit,
  onFieldChange,
  formTouched,
  deleteOvLine,
  addOvLine,
  setNetworkType,
  networkType,
  setFormTouched
}) => {
  const {
    contentfulValues: {
      officePhone: {
        add: addText,
        addOvLine: addOvLineText,
        deleteLine: deleteLineText
      }
    }
  } = getLocalizedStrings();
  return (
    <form onSubmit={onFormSubmit} name="officePhoneForm">
      {fieldRows.map(({ ovLines, fields: mainFields, key: fieldRowKey }) => (
        <RowBordered key={fieldRowKey}>
          <h1
            style={{ fontWeight: 'bold', fontSize: '16px', marginLeft: '20px' }}
          >
            Please qualify that your client is eligible for copper services
            within Check Services or Telus.com If this is a fibre only location
            please follow the Business Voice Over Fibre (BVOF) order process.
          </h1>
          <span style={{ marginLeft: '20px' }}>
            <FieldMultiCheckbox
              data={{
                name: 'networkType',
                label: 'Network Type',
                required: true,
                noteAppearsBelowField: false,
                isShowNoteBackground: false,
                readonly: false,
                disabled: false,
                value: networkType.data,
                onChange: e => {
                  const value = e.target.value;
                  setNetworkType({ data: value });
                  setFormTouched(true);
                },
                options: [
                  {
                    fields: {
                      label: 'Copper',
                      value: 'Copper',
                      disabledOption: false
                    }
                  }
                ]
              }}
            />
            {networkType.error && <Error text={networkType.error} />}
          </span>
          <FlexGrid.Row>
            {mainFields.map(
              field =>
                !field.fields.hidden && (
                  <FlexGrid.Col
                    xs={12}
                    md={6}
                    lg={3}
                    key={`mainFieldRowItem-${field.fields.name}`}
                  >
                    <Box vertical={2}>
                      <FormField
                        data={{
                          ...field.fields,
                          name: `${field.fields.name}`,
                          onChange: e =>
                            onFieldChange(
                              e,
                              field,
                              officePhoneRowTypes.mainRow,
                              mainFields
                            )
                        }}
                        error={field.fields.error}
                      />
                    </Box>
                  </FlexGrid.Col>
                )
            )}
          </FlexGrid.Row>
          {ovLines &&
            ovLines.map(({ fields: ovFields, key: ovLineKey }, index) => (
              <RowBordered key={ovLineKey}>
                <FlexGrid.Row>
                  {ovFields.map(
                    field =>
                      !field.fields.hidden && (
                        <FlexGrid.Col
                          xs={12}
                          md={6}
                          lg={3}
                          key={`fieldOvLineItem-${field.fields.name}]`}
                        >
                          <Box vertical={2}>
                            <FormField
                              data={{
                                ...field.fields,
                                disabled: field.fields.disabled,
                                name: `${field.fields.name}-${index}`,
                                onChange: e =>
                                  onFieldChange(e, field, 'ovLine', ovFields)
                              }}
                              error={field.fields.error}
                            />
                          </Box>
                        </FlexGrid.Col>
                      )
                  )}
                </FlexGrid.Row>
                {index === ovLines.length - 1 && (
                  <FlexGrid.Row>
                    <FlexGrid.Col xs={12}>
                      <Box vertical={2}>
                        <BtnMargin
                          className="frg-button color-purple"
                          mt="40px"
                          onClick={addOvLine}
                        >
                          {addOvLineText}
                        </BtnMargin>
                        {ovLines.length > 1 && (
                          <BtnMargin
                            className="frg-button color-purple"
                            mt="40px"
                            ml="10px"
                            onClick={() => deleteOvLine(index)}
                          >
                            {deleteLineText}
                          </BtnMargin>
                        )}
                      </Box>
                    </FlexGrid.Col>
                  </FlexGrid.Row>
                )}
                {index < ovLines.length - 1 && (
                  <FlexGrid.Row>
                    <FlexGrid.Col xs={12}>
                      <Box vertical={2}>
                        <BtnMargin
                          className="frg-button color-purple"
                          mt="40px"
                          onClick={() => deleteOvLine(index)}
                        >
                          {deleteLineText}
                        </BtnMargin>
                      </Box>
                    </FlexGrid.Col>
                  </FlexGrid.Row>
                )}
              </RowBordered>
            ))}
          <FlexGrid.Row>
            <FlexGrid.Col xs={12}>
              <Box vertical={2}>
                <BtnMargin
                  type="submit"
                  disabled={!formTouched}
                  className="frg-button color-purple"
                  mt="40px"
                >
                  {addText}
                </BtnMargin>
              </Box>
            </FlexGrid.Col>
          </FlexGrid.Row>
        </RowBordered>
      ))}
    </form>
  );
};

AddForm.defaultProps = {
  fieldRows: []
};

AddForm.propTypes = {
  fieldRows: PropTypes.arrayOf(PropTypes.any),
  onFormSubmit: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  addOvLine: PropTypes.func.isRequired,
  deleteOvLine: PropTypes.func.isRequired,
  formTouched: PropTypes.bool.isRequired
};

export default AddForm;
